import Decimal from "decimal.js";
import { DEV_ORIGIN } from "../App";

// 获取本地时区
export const getLocalTimeZone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

export function numLess1Formatter(num: number, precision: number = 4): string {
  if (num >= 1) throw new Error("Number must be less than 1");
  if (num <= 0) throw new Error("Number must be greater than 0");
  if (num >= 0.001) {
    const [integerPart, decimalPart = ""] = num.toString().split(".");
    let zeroCounts = 0;
    while (decimalPart[zeroCounts] === "0") {
      zeroCounts++;
    }
    const formattedDecimal = decimalPart
      .slice(0, zeroCounts + precision)
      .replace(/0+$/, "");

    return `${integerPart}${formattedDecimal ? "." + formattedDecimal : ""}`;
  }

  // 数字小于 0.001 时，按照特殊格式化规则
  const parts = Number(num)?.toFixed(20)?.split(".");
  const decimalPart = parts[1];
  let zeroCounts = 0;
  while (decimalPart[zeroCounts] === "0") {
    zeroCounts++;
  }
  const significantDigits = decimalPart.slice(
    zeroCounts,
    zeroCounts + precision
  );

  // 将前导零数转换为下标字符
  const subscriptZeroCount = zeroCounts
    .toString()
    .split("")
    .map((digit) => String.fromCharCode(8320 + parseInt(digit, 10)))
    .join("");
  return `0.0${subscriptZeroCount}${significantDigits}`;
}

export function numOver1Formatter(num: number, precision: number = 2): string {
  if (num < 1) throw new Error("Number must be greater than or equal to 1");

  const format = (n: number, decimals: number): string => {
    const [integerPart, decimalPart = ""] = n.toString().split(".");
    return [integerPart, decimalPart.slice(0, decimals).replace(/0+$/, "")]
      .filter((i) => i)
      .join(".");
  };

  if (num < 1000) {
    return format(num, precision);
  } else if (num < 1000000) {
    return `${format(num / 1000, precision)}K`;
  } else if (num < 10000000000) {
    return `${format(num / 1000000, precision)}M`;
  } else {
    return `${format(num / 1000000000, precision)}B`;
  }
}

export function numFormatter(num: number, precision: number = 2): string {
  if (num >= 1) {
    return numOver1Formatter(num, precision);
  } else if (num > 0 && num < 1) {
    return numLess1Formatter(num, precision);
  } else if (num < 0) {
    const val = Math.abs(num);
    if (val >= 1) {
      return `-${numOver1Formatter(val, precision)}`;
    } else {
      return `-${numLess1Formatter(val, precision)}`;
    }
  } else {
    return num?.toString();
  }
}

export const getDeviceType = (): "PC" | "iPhone" | "Android" => {
  const userAgent = navigator.userAgent || navigator.vendor;
  if (/iPhone/i.test(userAgent)) {
    return "iPhone";
  }
  if (/Android/i.test(userAgent)) {
    return "Android";
  }
  return "PC";
};

// 根据同源策略获取storage中的tokentgid
export function getTgId() {
  const common = localStorage.getItem("SOL_SPT_PC_common");
  if (!!common) {
    try {
      const commonObj = JSON.parse(common);
      return commonObj?.state?.rsaPublic?.tgId ?? undefined;
    } catch {}
  }
}
export function getLoginToken() {
  const common = localStorage.getItem("LOGIN_TOKEN");
  if (!!common) {
    return common;
    // try {
    //   const commonObj = JSON.parse(common);
    //   return commonObj?.state?.rsaPublic?.token ?? undefined;
    // } catch {}
  }
  return null;
}

export function postWindowMessage(message: any) {
  window.parent.postMessage(message, location.origin);
  window.parent.postMessage(message, DEV_ORIGIN);
  window.parent.postMessage(message, "https://spt.fun");
  window.parent.postMessage(message, "https://dev.sol.win");
}
